<template>
  <div id="design">
    <div class="container">
      <h1>Design</h1>
      <hr>
      <form @submit.prevent>
        <!-- CUSTOM CSS -->
        <div class="form-group">
          <label for="customCss">Custom CSS</label>
          <textarea
            v-model="dashboard.data.design.css"
            id="customCss"
            class="form-control"
            rows="10"
          ></textarea>
        </div><!-- /.form-group -->
        <button
          @click="saveDesign()"
          class="btn btn-primary"
        >Save</button>
      </form>
    </div><!-- /.container -->
  </div><!-- /#design -->
</template>

<script>
  import { mapState } from 'vuex'
  const fb = require('../../firebaseConfig.js')

  export default {
    computed: {
      ...mapState([
        'dashboard'
      ])
    },
    created() {
      if (!this.dashboard.data.design) {
        this.dashboard.data.design = {css: ''}
      }
    },
    methods: {
      saveDesign() {
        fb.dashboardsCollection.doc(this.dashboard.data.id).update({
          design: this.dashboard.data.design
        }).then(e => {
          const revData = this.dashboard.data
          revData.updatedOn = new Date()
          fb.dashboardRevisionsCollection.add(revData)
          alert('Custom CSS saved!')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/Design.vue